<template>
    <div class="article-faqs-tile-experience">
        <p>
            Certainly! Our beginner classes are designed for people with no prior dance experience whatsoever. So many
            people tell us they have 'two left feet', that they're different somehow. But trust us, anyone can learn to
            dance if they just give classes a try.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleFaqsTileExperience',
};
</script>
